export const PAGINATION_SIZE = 5;

export const FOR_YOU_PAGE_SIZE = 3;
